import { IClass } from '../store/BookmarkSlice';
import { TTheme } from '../store/ConfigSlice';
import { IUser } from '../store/UserSlice';

// GET FROM LOCAL STORAGE
export const getAppThemeModeFromLocalStorage = (): TTheme | undefined => {
  const data = localStorage.getItem('TUTOPIYA_QUIZ_APP_THEME_MODE');
  const mode: TTheme = (data as TTheme) || 'light';
  return mode.trim() as TTheme;
};

export const getAuthTokenFromLocalStorage = (): string | undefined => {
  const data = localStorage.getItem('TUTOPIYA_QUIZ_AUTH_TOKEN');
  if (data) {
    return data;
  }
  return undefined;
};

export const getAuthUserFromLocalStorage = (): IUser | undefined => {
  const data = localStorage.getItem('TUTOPIYA_QUIZ_AUTH_USER');
  if (data) {
    return JSON.parse(data) as IUser;
  }
  return undefined;
};

export const getClassFromLocalStorage = (): IClass | undefined => {
  const data = localStorage.getItem('TUTOPIYA_QUIZ_CLASS');
  if (data) {
    return JSON.parse(data) as IClass;
  }
  return undefined;
};

export const getPDFThemeModeFromLocalStorage = (): TTheme | undefined => {
  const data = localStorage.getItem('TUTOPIYA_PDF_THEME_MODE');
  const mode: TTheme = (data as TTheme) || 'light';
  return mode.trim() as TTheme;
};

export const getAdminPortalEditModeValueFromLocalStorage = ():
  | string
  | undefined => {
  const value = localStorage.getItem('TUTOPIYA_ADMIN_EDIT_MODE_VALUE');

  return value || undefined;
};

// SET TO LOCAL STORAGE
export const setAuthTokenToLocalStorage = (token: string): void => {
  localStorage.setItem('TUTOPIYA_QUIZ_AUTH_TOKEN', token);
};

export const setAuthUserToLocalStorage = (user: IUser): void => {
  localStorage.setItem('TUTOPIYA_QUIZ_AUTH_USER', JSON.stringify(user));
};

export const setAppThemeModeToLocalStorage = (mode: TTheme): void => {
  localStorage.setItem('TUTOPIYA_QUIZ_APP_THEME_MODE', mode as string);
};

export const setClassToLocalStorage = (bookmark: IClass): void => {
  localStorage.setItem('TUTOPIYA_QUIZ_CLASS', JSON.stringify(bookmark));
};

export const setPDFThemeModeToLocalStorage = (mode: TTheme): void => {
  localStorage.setItem('TUTOPIYA_PDF_THEME_MODE', mode as string);
};

export const setAdminPortalEditModeValueToLocalStorage = (
  value: string
): void => {
  localStorage.setItem('TUTOPIYA_ADMIN_EDIT_MODE_VALUE', value);
};

// REMOVE FROM LOCAL STORAGE
export const removeAuthTokenToLocalStorage = (): void => {
  localStorage.removeItem('TUTOPIYA_QUIZ_AUTH_TOKEN');
};

export const removeAuthUserToLocalStorage = (): void => {
  localStorage.removeItem('TUTOPIYA_QUIZ_AUTH_USER');
};

export const removeClassFromLocalStorage = (): void => {
  localStorage.removeItem('TUTOPIYA_QUIZ_CLASS');
};

export const removeAdminPortalEditModeValueFromLocalStorage = (): void => {
  localStorage.removeItem('TUTOPIYA_ADMIN_EDIT_MODE_VALUE');
};
